import React, { FC } from "react";

import useFileTypeQualifier from "../../hooks/use-file-type-qualifier";

import Player360 from "./player-360";
import styles from "./box-preview.module.css";

type BoxProps = {
  file: string;
};

const BoxPreview: FC<BoxProps> = (props) => {
  const { file } = props;
  const { isVideo } = useFileTypeQualifier();

  // Additional file type checks
  const isPhoto = (file: string): boolean => {
    const fileType = file.split(".").pop()?.toLowerCase();
    return ["jpg", "jpeg", "png", "gif", "webp"].includes(fileType);
  };

  if (!file) return null;

  if (isPhoto(file)) {
    return (
      <div className={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: "100%",
            alignItems: "center",
          }}
        >
          <img src={file} style={{ maxWidth: "100%", maxHeight: "99%" }} />
        </div>
      </div>
    );
  }

  if (isVideo(file)) {
    if (file.includes(".360.")) {
      return <Player360 file={file} />;
    }
    return (
      <div className={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <video
            controls
            autoPlay
            loop
            style={{ maxWidth: "100%", maxHeight: "99%" }}
            key={file}
          >
            <source src={file} />
          </video>
        </div>
      </div>
    );
  }

  // Default fallback for other file types
  return (
    <div className={styles.container}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <div>{file}</div>
        <div style={{ fontSize: "12px" }}>Не удалось отобразить файл</div>
      </div>
    </div>
  );
};

export default BoxPreview;
